// extracted by mini-css-extract-plugin
export default {"root":"ImagePreview_root__tDjTd","pdf":"ImagePreview_pdf__O-0xY","icon":"ImagePreview_icon__fZJbv"};